import { DirectCustomer } from './direct-customer.model';

export class DirectCustomerSecurityQuestion {
  public DirectCustomerID: number;
  public SecurityQuestionCode: string;
  public Answer: string;
  public DirectCustomer: DirectCustomer;
  public Id: string;
}
